/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProgramPeriodConfig } from '../../models/program-period-config';

export interface FindOneAdminProgramPeriodConfig$Params {
  id: string;
}

export function findOneAdminProgramPeriodConfig(
  http: HttpClient,
  rootUrl: string,
  params: FindOneAdminProgramPeriodConfig$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<ProgramPeriodConfig>> {
  const rb = new RequestBuilder(rootUrl, findOneAdminProgramPeriodConfig.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProgramPeriodConfig>;
    })
  );
}

findOneAdminProgramPeriodConfig.PATH = '/admin/program-period-configs/{id}';
